import React, {memo} from 'react';

import moment from 'moment-tz';

import {
  getActivityOrNotificationDescription,
  StyledGeneralDescriptionSpan,
} from 'app/activity/shared-utils';
import {StyledCompactItemHeaderDiv} from 'app/general/bootstrap/utils';

import type {ActivityType} from 'app/activity/types';

type Props = {
  object: ActivityType;
};

export const ActivityItem = memo<Props>(({object}: Props) => {
  return (
    <div className="row border-bottom py-2">
      <StyledCompactItemHeaderDiv>
        <StyledGeneralDescriptionSpan>
          <span>{getActivityOrNotificationDescription(object)}</span>
        </StyledGeneralDescriptionSpan>
      </StyledCompactItemHeaderDiv>
      <div className="col col-lg-2">
        <small>
          <span title={moment(object.timestamp).format('lll')}>
            {moment(object.timestamp).fromNow()}
          </span>
        </small>
      </div>
    </div>
  );
});
